import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
// Soft UI Context Provider
import { SoftUIControllerProvider } from "./context";
import "./custom-overlay.css";
import App from "./App";
import store from "redux/store";
import "./i18n";
import { createRoot } from "react-dom/client";

import Auth0ProviderWithHistory from "authentication/Auth0ProviderWithHistory";

import AppContextProvider from "context/AppProvider";
import { useSetConfigs } from "hooks/useSetConfigs";
import { ToastNotification } from "components/Notification/Toast";

function Root() {
  const { isFinishedSettingConfigs } = useSetConfigs();

  if (!isFinishedSettingConfigs) return null;

  return (
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <SoftUIControllerProvider>
          <AppContextProvider>
            <Provider store={store}>
              <>
                <App />
                <ToastNotification />
              </>
            </Provider>
          </AppContextProvider>
        </SoftUIControllerProvider>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<Root />);
